// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"661":"b8fe6154","885":"d5ce92fc"}[chunkId] + ".chunk.js";
};